export default __webpack_public_path__ + "static/media/32M.3b58decf.jpeg";